<template>
  <div>
    <div>
      <show-condition-group
        :index="n"
        :class="[conditionGroupCount > 0 ? 'show-condition-group' : '']"
        v-for="n in conditionGroups"
        :key="n"
        module-id="1"
      >
      </show-condition-group>
    </div>
    <button class="btn" type="button" v-on:click="addConditionGroup()">
      Add condition
    </button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      conditionGroupCount: 0,
      conditionGroups: [],
    };
  },

  methods: {
    addConditionGroup: function () {
      this.conditionGroups.push({});
      this.conditionGroupCount += 1;
    },
  },
};
</script>

<style>
.show-condition-group {
  border: 2px solid gray;
}
</style>
